import type { StudyState } from '../state';

export const updateEventInHypnogramData = (
  state: StudyState,
  payload: { id: string; type: string; start: string; duration: number }
) => {
  const { id, type, start, duration } = payload;

  const hypnoData = state?.hypnogram?.data?.data || [];
  const eventIndex = hypnoData.findIndex((event) => event.id === id);

  if (eventIndex !== -1 && state?.hypnogram?.data?.data[eventIndex]) {
    state.hypnogram.data.data[eventIndex] = {
      id,
      eventType: type,
      start: new Date(start).getTime() / 1000,
      duration,
      end: new Date(start).getTime() / 1000 + duration
    };
  }
};

export const updateHypnogramEvents = (state: StudyState, payload: { data: any }) => {
  if (payload?.data) {
    const { data } = payload;
    state.hypnogram.data = { ...data };
  } else {
    state.hypnogram.data = undefined;
  }
};

export const setHypnogramData = (state: StudyState, payload: any) => {
  state.hypnogram.data = payload;
};
